import {ValueObject} from '@s-ui/domain'

import {QueryParamSharedValueObject} from '../../shared/ValueObjects/QueryParamSharedValueObject.js'
import {FilterBooleanSearchValueObject} from './FilterBooleanSearchValueObject.js'

export class FilterHasPriceDropSearchValueObject extends ValueObject {
  #hasPriceDrop

  constructor({hasPriceDrop}) {
    super()
    this.#hasPriceDrop = hasPriceDrop
  }

  static create({hasPriceDrop}) {
    return new FilterHasPriceDropSearchValueObject({hasPriceDrop: FilterBooleanSearchValueObject.create(hasPriceDrop)})
  }

  static createWithDefaultValue({config, hasPriceDrop}) {
    const {DEFAULT_HAS_PRICE_DROP_SEARCH} = config.get('searchFilters')

    return new FilterHasPriceDropSearchValueObject({
      hasPriceDrop: FilterBooleanSearchValueObject.create({boolean: hasPriceDrop ?? DEFAULT_HAS_PRICE_DROP_SEARCH})
    })
  }

  static createQueryParams({config, hasPriceDrop}) {
    const {DEFAULT_HAS_PRICE_DROP_SEARCH, FILTER_NAMES, FILTER_QUERY_PARAMS} = config.get('searchFilters')

    return new FilterHasPriceDropSearchValueObject({
      hasPriceDrop: QueryParamSharedValueObject.createForSingle({
        key: FILTER_QUERY_PARAMS[FILTER_NAMES.HAS_PRICE_DROP],
        value: hasPriceDrop === DEFAULT_HAS_PRICE_DROP_SEARCH ? null : hasPriceDrop
      })
    })
  }

  get isEmpty() {
    return this.#hasPriceDrop.isEmpty
  }

  get queryParams() {
    return {
      ...(!this.isEmpty && {...this.#hasPriceDrop.queryParam})
    }
  }

  get value() {
    return this.#hasPriceDrop.value
  }

  toJSON() {
    return {
      hasPriceDrop: this.#hasPriceDrop.toJSON()
    }
  }
}
